<template>
  <section>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-card class="mb-6 ml-6 mr-2 mt-4">
          <v-form ref="form" lazy-validation>
            <v-card-title>Modification Actualités : {{ actualityInfo.title }}</v-card-title>
            <v-card-text class="mt-4">
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-select v-model="actualityInfo.actualityCategoryEntity.id" :items="ActualityCategoryList"
                    item-text="label" item-value="id" label="catégorie de l'actualité" outlined
                    @change="getSubCategorie" required></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-select v-model="actualityInfo.actualitySubCategoryId" :items="actualitySubCategoryList"
                    item-text="label" item-value="id" label="Sous-catégorie de l'actualité" outlined
                    required></v-select>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <v-text-field v-model="actualityInfo.title" label="Titre" outlined required></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field v-model="actualityInfo.titleEn" label="Titre en anglais" outlined
                    required></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field v-model="actualityInfo.overview" label="Overview" outlined required></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field v-model="actualityInfo.overviewEn" label="Overview en anglais" outlined
                    required></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field v-model="actualityInfo.highlight" label="Highlight" outlined></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field v-model="actualityInfo.highlightEn" label="Highlight en anglais"
                    outlined></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field v-if="actualityInfo.highlight && actualityInfo.highlight.length >= 1"
                    v-model="actualityInfo.reportBy" label="Rapporté par" outlined
                    :required="isReportByRequired"></v-text-field>
                </v-col>
                <!--
                <template v-if="
                  actualityInfo.actualityCategory !== 'PERSONNAGE' &&
                  actualityInfo.actualityCategory !== 'PATRIMOINE' &&
                  actualityInfo.actualityCategory !== 'ARTICLE'
                ">
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field label="Sous-Titre" v-model="actualityInfo.subtitle" outlined required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field label="Sous-Titre en anglais" v-model="actualityInfo.subtitleEn" outlined
                      required></v-text-field>
                  </v-col>
                </template>
-->
                <template v-if="
                  actualityInfo.actualityCategory !== 'PERSONNAGE' &&
                  actualityInfo.actualityCategory !== 'PATRIMOINE'
                ">
                  <v-col cols="12" sm="12" md="12">
                    <VueEditor v-model="actualityInfo.description" auto-grow outlined label="Description"
                      placeholder="Description">
                    </VueEditor>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <VueEditor v-model="actualityInfo.descriptionEn" auto-grow outlined label="Description en anglais"
                      placeholder="Description en anglais">
                    </VueEditor>
                  </v-col>
                </template>
              </v-row>
              <v-row>
                <!--
                <v-col cols="12">
                  <v-autocomplete v-model="selectTags" :items="tagsArray" item-text="title" item-value="id" label="Tags"
                    chips deletable-chips multiple outlined></v-autocomplete>
                </v-col>
                -->
                <v-col cols="12">
                  <v-text-field label="Tags en francais" v-model="actualityInfo.TagsTextFr" outlined
                    required></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field label="Tags en anglais" v-model="actualityInfo.TagsTextEn" outlined
                    required></v-text-field>
                </v-col>
                <v-col cols="12" v-if="showTagsError && tagsfrList.length !== tagsEnList.length">
                  <v-alert type="error" dense class="mb-0">
                                    Erreur : Le nombre de tags en français ({{ tagsfrList.length }}) et en anglais ({{ tagsEnList.length }}) doit être identique !
                  </v-alert>
                </v-col>

                <v-col cols="12">
                  <v-text-field v-model="actualityInfo.actualityRank" label="Rang" outlined required type="number"
                    min="0"></v-text-field>
                </v-col>

              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="4" v-if="actualityInfo.title">
                  <vue-upload-multiple-image :idUpload="imagesId" v-model="images" :data-images="images"
                    accept="image/*	" name="images" drag-text="Veuillez ajoutez une images svp!"
                    browse-text="Browse image" primary-text="Primary image" mark-is-primary-text="Set default image"
                    :min-image="1" :multiple="false" :showEdit="false" popup-text="Description default image"
                    drop-text="Drag and drop" @upload-success="uploadImageSuccess" @before-remove="beforeRemove">
                  </vue-upload-multiple-image>
                  <v-progress-linear v-if="showlowding && uploadPercentage < 100"
                    style="max-width: 190px; margin-left: 160px" color="primary" indeterminate rounded
                    height="15"><strong>{{ Math.ceil(uploadPercentage)
                    }}%</strong></v-progress-linear>
                  <!-- <v-btn
                    color="info darken-1"
                    text
                    @click="
                      () =>
                        uploadFirebaseUrls(
                          actualityInfo.id,
                          actualityInfo.imgUrl
                        )
                    "
                    >modifier</v-btn
                  > -->
                </v-col>
                <!--
                <v-col cols="12" sm="12" md="4" v-if="actualityInfo.title">
                  <vue-upload-multiple-image :idUpload="imagesIdBanner" v-model="imagesBanner"
                    :data-images="imagesBanner" accept="image/*	" name="imagesBanner"
                    drag-text="Veuillez ajoutez une images Banner!" browse-text="Browse image"
                    primary-text="Primary image" mark-is-primary-text="Set default image" :min-image="1"
                    :multiple="false" :showEdit="false" popup-text="Description default image" drop-text="Drag and drop"
                    @upload-success="uploadImageSuccessBanner" @before-remove="beforeRemoveBanner">
                  </vue-upload-multiple-image>
                  <v-progress-linear v-if="showlowdingBanner && uploadPercentageBanner < 100"
                    style="max-width: 190px; margin-left: 160px" color="primary" indeterminate rounded
                    height="15"><strong>{{
                      Math.ceil(uploadPercentageBanner) }}%</strong></v-progress-linear>
                </v-col>
                -->
                <v-col cols="12" sm="12" md="3">
                  <v-row align="center">
                    <v-col cols="auto" style="margin-top: 16px">
                      <span>Premium:</span>
                    </v-col>
                    <v-col cols="auto">
                      <v-switch v-model="actualityInfo.isLocked" hide-details inset></v-switch>
                    </v-col>
                    <v-col cols="auto">
                      <v-icon color="#00a325" v-if="!actualityInfo.isLocked">
                        {{ icons.mdiLockOpen }}
                      </v-icon>
                      <v-icon color="warning" v-if="actualityInfo.isLocked">
                        {{ icons.mdiLock }}
                      </v-icon>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="12" md="3">
                  <v-row align="center">
                    <v-col cols="auto" style="margin-top: 16px">
                      <span>certified :</span>
                    </v-col>
                    <v-col cols="auto">
                      <v-switch v-model="certified" hide-details inset></v-switch>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col v-if="certified">
                  <v-select v-model="authorSelected" clearable label="Author" :items="authorList" item-text="name"
                    item-value="id" outlined></v-select>
                </v-col>
              </v-row>
              <v-row>

              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <div class="d-flex flex-row-reverse">
                    <v-btn @click="UpdateActuality()" color="info darken-1" :disabled="!canSubmitActuality()">
                      Enregistrer
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
        <v-row v-if="
          actualityInfo.actualityCategory == 'PERSONNAGE' ||
          actualityInfo.actualityCategory == 'PATRIMOINE'
        ">
          <v-col cols="12" sm="12" md="6">
            <v-row>
              <v-col cols="12" sm="12" md="3">
                <v-btn @click="dialogAddCard = true" class="info ml-6 mr-2 mt-4">
                  <v-icon left> {{ icons.mdiDatabasePlusOutline }} </v-icon>
                  Ajouter un Élément
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-card class="mb-6 ml-6 mt-6 mr-2" v-if="
          actualityInfo.actualityCategory == 'PERSONNAGE' ||
          actualityInfo.actualityCategory == 'PATRIMOINE'
        ">
          <v-card-title>Élément d'actualité</v-card-title>
          <v-data-table :footer-props="{
            'items-per-page-options': [5, 10, 15, 30],
          }" class="elevation-1" item-key="id" :headers="headers" :items="ActualityDescItemist">
            <template v-slot:[`item.modifier`]="{ item }">
              <v-icon @click="redirectToEditDescItem(item)">
                {{ icons.mdiPencil }}
              </v-icon>
            </template>
            <template v-slot:[`item.supprimer`]="{ item }">
              <v-icon @click="suppressionAction(item.id)">
                {{ icons.mdiDeleteOutline }}
              </v-icon>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogEditActuality" max-width="600">
        <v-card>
          <v-card-title class="text-h6">
            Etes vous sur de vouloir Modifier l'actualité ?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="error darken-1 error" text @click="dialogEditActuality = false">
              Annuler
            </v-btn>

            <v-btn color="info darken-1 " text @click="UpdateActuality()">
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogAddCard" persistent max-width="800px">
        <v-card>
          <v-card-title>
            <span class="text-h5">Informations d'élément </span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="form">
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="title" label="Nom" outlined></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <VueEditor v-model="description" auto-grow outlined label="Description" placeholder="Description">
                    </VueEditor>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error darken-1 error" text @click="reinitialisationFormulaire()">
              Annuler
            </v-btn>
            <v-btn :disabled="description.length <= 0 || title.length <= 0" color="info darken-1 "
              @click="dialogConfirmAddDescItem = true" text>
              Enregistrer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogConfirmAddDescItem" max-width="530">
        <v-card>
          <v-card-title class="text-h6">
            Etes vous sur de vouloir ajouter l'élément ?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="error darken-1 error" text @click="dialogConfirmAddDescItem = false">
              Annuler
            </v-btn>

            <v-btn color="info darken-1 " text @click="ajoutActualityDescItem()">
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog max-width="530" v-model="dialogRemoveDescItem">
        <v-card>
          <v-card-title class="text-h6">
            Etes vous sur de vouloir supprimer l'actualité ?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="deleteDescItem()" color="info darken-1 " text>
              Confirmer
            </v-btn>
            <v-btn @click="dialogRemoveDescItem = false" color="error darken-1 error" text>
              Annuler
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogEditDescItem" persistent max-width="800px">
        <v-card>
          <v-card-title>
            <span class="text-h5">Informations d'élément </span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="form">
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="actualityDescItemInfo.title" label="Nom" outlined></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <VueEditor v-model="actualityDescItemInfo.description" auto-grow outlined label="Description"
                      placeholder="Description">
                    </VueEditor>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error darken-1 error" @click="dialogEditDescItem = false" text>
              Annuler
            </v-btn>
            <v-btn @click="dialogConfirmerEditDescItem = true" :disabled="actualityDescItemInfo.description.length <= 0 ||
              actualityDescItemInfo.title.length <= 0
              " color="info darken-1 " text>
              Enregistrer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogConfirmerEditDescItem" max-width="530">
        <v-card>
          <v-card-title class="text-h6">
            Etes vous sur de vouloir Modifier l'élément ?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="error darken-1 error" text @click="dialogConfirmerEditDescItem = false">
              Annuler
            </v-btn>

            <v-btn color="info darken-1 " text @click="EditActualityDescItem()">
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </section>
</template>
<script>
import firebase from "firebase/compat/app";
import "firebase/compat/storage";
import { component as VueCodeHighlight } from "vue-code-highlight";
import { VueEditor } from "vue2-editor/dist/vue2-editor.core.js";
import {
  mdiPlus,
  mdiDeleteOutline,
  mdiPencil,
  mdiDatabasePlusOutline,
  mdiLockOpen,
  mdiLock,
} from "@mdi/js";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import axios from "axios";
import Constant from "@/utils/constants";
import store from "../../../store/image";

import {
  FetchAllTags,
  getAllActualityCategory,
  getAllActualityDescItem,
} from "@/views/qorani/services/services";
export default {
  components: { VueUploadMultipleImage, VueEditor, VueCodeHighlight },
  data() {
    return {
      actualitySubCategoryList: [],
      select: {},
      selectTags: [],
      initialTags: [],
      certified: false,
      authorList: [],
      authorSelected: null,
      tagsArray: [],
      actualites: [],
      imagesId: "1",
      imagesIdBanner: "0",
      showLoadingBanner: false,
      showlowding: false,
      showlowdingBanner: false,
      dialogConfirmerEditDescItem: false,
      dialogConfirmAddDescItem: false,
      description: "",
      title: "",
      overview: "",
      headers: [
        { text: "Titre", value: "title" },
        { text: "Description", value: "description" },
        { text: "Modifier", value: "modifier", align: "center" },
        { text: "Supprimer", value: "supprimer", align: "center" },
      ],
      dialogEditActuality: false,
      icons: {
        mdiPlus,
        mdiDeleteOutline,
        mdiPencil,
        mdiDatabasePlusOutline,
        mdiLockOpen,
        mdiLock,
      },
      ActualityDescItemist: [],
      ActualityCategoryList: [],
      images: [],
      imagesBanner: [],
      actualityInfo: {
        id: "",
        title: "",
        titleEn: "",
        overview: "",
        overviewEn: "",
        subtitle: "",
        subtitleEn: "",
        description: "",
        descriptionEn: "",
        actualityRank: 0,
        imgUrl: "",
        imgId: "",
        isLocked: "",
        imgBannerUrlId: "",
        imgBannerUrl: "",
        actualityCategory: [],
        actualityCategoryEntity: {
          id: "",
        },
        highlight: "",
        highlightEn: "",
        reportBy: "",
        actualityCategoryId: "",
        actualitySubCategoryId: "",
        actualityRank: 1,
        TagsTextFr: "",
        TagsTextEn: "",
      },
      actuality: {
        id: "",
        title: "",
        titleEn: "",
        subtitle: "",
        subtitleEn: "",
        description: "",
        descriptionEn: "",
        imgUrlDBId: "",
        imgBannerUrDBlId: "",
        isLocked: "",
        author: {
          id: "",
        },
        actualityRank: 1,
      },
      actualityDescItem: {
        title: "",
        description: "",
        actualityId: "",
      },
      actualityDescItemInfo: {
        title: "",
        description: "",
        id: "",
        actualityId: "",
      },
      dialogAddCard: false,
      DescItemIdSupprimmer: "",
      dialogRemoveDescItem: false,
      dialogEditDescItem: false,
      uploadPercentage: null,
      uploadPercentageBanner: null,
      fakePercentage: null,
      imageInfo: {
        fileName: "",
        fileUrl: "",
      },
      imageInfoBanner: {
        fileName: "",
        fileUrl: "",
      },
      showTagsError: false,
    };
  },
  async beforeRouteEnter(to, from, next) {
    const actualityId = to.params.id;
    try {
      const responseActuality = await axios.get(
        `${Constant.QORANI}actuality/get/${actualityId}`
      );
      const responseAuthor = await axios.get(
        `${Constant.QORANI}authorCertificate/getall`
      );
      const responseActualitySubCategory = await axios.get(
        `${Constant.QORANI}actualitySubCategory/getAllByActualityCategoryId/${responseActuality.data.actualityCategoryEntity.id}`
      );


      next((vm) => {
        vm.actualitySubCategoryList = responseActualitySubCategory.data;

        const tagsFr = (responseActuality.data.tagList || [])
          .map((tag) => tag.title)
          .join(", ");
        const tagsEn = (responseActuality.data.tagList || [])
          .map((tag) => tag.titleEn)
          .join(", ");

        vm.actualityInfo = {
          ...responseActuality.data,
          TagsTextFr: tagsFr,
          TagsTextEn: tagsEn,
        };

        vm.authorList = responseAuthor.data;
        vm.authorSelected = responseActuality.data.author
          ? responseActuality.data.author.id
          : null;
        vm.certified = responseActuality.data.author ? true : false;
        const rawTags = responseActuality.data.tagList || [];
        const tagIds = rawTags.map(tag => tag?.id ?? tag);
        vm.selectTags = [...tagIds];
        vm.initialTags = [...tagIds];
        const imgUrl =
          vm.getImageUrl(responseActuality.data.imgDBId) ||
          responseActuality.data.imgUrl;
        console.log(imgUrl);
        vm.images.push({
          name: "",
          path: imgUrl,
          highlight: 1,
          default: 1,
        });

        const imgBannerUrl =
          vm.getImageUrlBanner(responseActuality.data.imgBannerDBId) ||
          responseActuality.data.imgBannerUrl;

        vm.imagesBanner.push({
          name: "",
          path: imgBannerUrl,
          highlight: 1,
          default: 1,
        });
      });
    } catch (error) {
      console.error("Error fetching product details:", error);
      next(null);
    }
  },
  computed: {
    tagsfrList() {
      const rawFr = this.actualityInfo?.TagsTextFr || "";
      console.log("rawfr",rawFr);
      return rawFr
        ? rawFr.split(",").map((t) => t.trim()).filter(Boolean)
        : [];
    },
    tagsEnList() {
      const rawEn = this.actualityInfo?.TagsTextEn || "";
      console.log("rawen",rawEn);
      return rawEn
        ? rawEn.split(",").map((t) => t.trim()).filter(Boolean)
        : [];
    },
    isReportByRequired() {
      return !!this.highlight || !!this.highlightEn;
    },
  },
  methods: {
    async existTag() {
      const tagsfrList = this.tagsfrList;
      const tagsEnList = this.tagsEnList;

      if (tagsfrList.length !== tagsEnList.length) {
        this.showTagsError = true;
        console.error(
          "Erreur : Les longueurs de TagsTextFr et TagsTextEn ne sont pas égales !"
        );
        return false;
      }
      this.showTagsError = false;

      if (!this.tagsArray || this.tagsArray.length === 0) {
        this.tagsArray = (await FetchAllTags()) || [];
      }

      const tagsid = [];

      for (let i = 0; i < tagsfrList.length; i++) {
        const titleFr = tagsfrList[i];
        const titleEn = tagsEnList[i];

        const existingTag = (this.tagsArray || []).find(
          (tag) =>
            (tag.title &&
              tag.title.trim().toLowerCase() === titleFr.toLowerCase()) ||
            (tag.titleEn &&
              tag.titleEn.trim().toLowerCase() === titleEn.toLowerCase())
        );

        if (existingTag) {
          if (!tagsid.some((id) => String(id) === String(existingTag.id))) {
            tagsid.push(existingTag.id);
          }
        } else {
          try {
            const missingPayloads = {
              title: titleFr,
              titleEn: titleEn,
            };
            const response = await axios.post(
              `${Constant.QORANI}tag/add`,
              missingPayloads
            );
            if (response.data && response.data.id) {
              tagsid.push(response.data.id);
              if (this.tagsArray) {
                this.tagsArray.push(response.data);
              }
            }
          } catch (error) {
            console.error("Erreur lors de l'ajout du tag :", titleFr, error);
          }
        }
      }

      this.selectTags = [...tagsid];

      const actualityId = this.actualityInfo.id;
      const tagsToAdd = tagsid.filter(
        (id) =>
          !this.initialTags.some((initId) => String(initId) === String(id))
      );
      const tagsToRemove = this.initialTags.filter(
        (id) => !tagsid.some((tagId) => String(tagId) === String(id))
      );

      console.log("Tags sélectionnés (IDs):", tagsid);
      console.log("Tags à ajouter (tagsToAdd):", tagsToAdd);
      console.log("Tags à supprimer (tagsToRemove):", tagsToRemove);

      try {
        if (tagsToAdd.length > 0) {
          await axios.post(`${Constant.QORANI}actuality/addTagsToActuality`, {
            actualityId: actualityId,
            tagIds: tagsToAdd,
          });
        }

        if (tagsToRemove.length > 0) {
          await axios.post(
            `${Constant.QORANI}actuality/removeTagsFromActuality`,
            {
              actualityId: actualityId,
              tagIds: tagsToRemove,
            }
          );
        }

        this.initialTags = [...tagsid];
      } catch (tagError) {
        console.error("Erreur lors de la synchronisation des tags:", tagError);
      }

      return tagsid;
    },
    async getSubCategorie(val) {
      const categoryId = this.actualityInfo.actualityCategoryEntity.id;
      try {
        const response = await axios.get(
          `${Constant.QORANI}actualitySubCategory/getAllByActualityCategoryId/${categoryId}`
        );
        this.actualitySubCategoryList = response.data;
      } catch (error) {
        console.error("Error fetching subcategories:", error);
      }
    },
    async filterFirebaseUrls() {
      for (const theme of this.actualites) {
        const firebaseUrls = theme.listFileUrl.filter((url) =>
          url.includes("firebase")
        );
        if (firebaseUrls.length > 0) {
          console.log(`theme ID: ${theme.id}, Firebase URLs:`, firebaseUrls);
          await this.uploadFirebaseUrls(theme.id, firebaseUrls);
        }
      }
    },


    getImageUrl(imgDBId) {
      if (imgDBId != null) {
        return `${Constant.QORANI}fileDB/files/${imgDBId}`;
      } else {
        return null;
      }
    },
    getImageUrlBanner(imgBannerDBId) {
      if (imgBannerDBId != null) {
        return `${Constant.QORANI}fileDB/files/${imgBannerDBId}`;
      } else {
        return null;
      }
    },
    async EditActualityDescItem() {
      const response = await fetch(
        Constant.QORANI +
        "actualityDescItem/edit/" +
        this.actualityDescItemInfo.id,

        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(this.actualityDescItemInfo),
        }
      );

      try {
        window.location.reload();
      } catch (error) {
        alert(
          "Une erreur est survenue lors de l'ajout du theme, veuillez réessayez plus tard, Merci."
        );
      }
    },
    redirectToEditDescItem(item) {
      this.actualityDescItemInfo.title = item.title;
      this.actualityDescItemInfo.description = item.description;
      this.actualityDescItemInfo.id = item.id;
      this.actualityDescItemInfo.actualityId = this.$route.params.id;
      this.dialogEditDescItem = true;
    },
    async deleteDescItem() {
      const response = await fetch(
        Constant.QORANI +
        `actualityDescItem/delete/${this.DescItemIdSupprimmer}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      try {
        window.location.reload();
      } catch (error) {
        alert(
          "Une erreur est survenue lors de la suppression du juz, veuillez réessayez plus tard, Merci."
        );
        this.dialogRemoveDescItem = false;
      }
    },
    suppressionAction(item) {
      this.DescItemIdSupprimmer = item;
      // this.dialogRemoveDescItem = true;
      this.deleteDescItem();
    },
    async ajoutActualityDescItem() {
      this.actualityDescItem.title = this.title;
      this.actualityDescItem.description = this.description;
      this.actualityDescItem.actualityId = this.$route.params.id;

      const responseCategorie = await fetch(
        Constant.QORANI + "actualityDescItem/add",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(this.actualityDescItem),
        }
      );

      try {
        this.reinitialisationFormulaire();
        window.location.reload();
      } catch (error) {
        alert(
          "Une erreur est survenue lors de l'ajout du theme, veuillez réessayez plus tard, Merci."
        );
      }
    },
    reinitialisationFormulaire() {
      this.title = "";
      this.description = "";
      this.dialogAddCard = false;
    },
    canSubmitActuality() {
      if (!this.actualityInfo.title?.trim() || !this.actualityInfo.titleEn?.trim()) return false;
      if (!this.actualityInfo.overview?.trim() || !this.actualityInfo.overviewEn?.trim()) return false;

      const categoryName = this.actualityInfo.actualityCategory || '';
      if (!['PERSONNAGE', 'PATRIMOINE'].includes(categoryName)) {
        if (!this.actualityInfo.description?.trim() || !this.actualityInfo.descriptionEn?.trim()) return false;
      }

      if (this.actualityInfo.isScheduled && !this.actualityInfo.scheduledDateTime) return false;
      if ((this.actualityInfo.highlight?.trim() || this.actualityInfo.highlightEn?.trim()) && !this.actualityInfo.reportBy?.trim()) return false;
      if (this.actualityInfo.certified && !this.actualityInfo.authorSelected) return false;

      return true;
    },
    async UpdateActuality() {

      if (!this.canSubmitActuality()) return;

      const tagSyncSuccess = await this.existTag();
      if (tagSyncSuccess === false) {
        return;
      }

      const imageId = store.state.imageId;
      const imageIdBanner = store.state.imageIdBanner;
      this.actuality.actualityCategoryId = this.actualityInfo.actualityCategoryEntity.id;
      this.actuality.actualitySubCategoryId = this.actualityInfo.actualitySubCategoryId;
      this.actuality.title = this.actualityInfo.title;
      this.actuality.titleEn = this.actualityInfo.titleEn;
      this.actuality.overview = this.actualityInfo.overview;
      this.actuality.overviewEn = this.actualityInfo.overviewEn;
      this.actuality.subtitle = this.actualityInfo.overview;
      this.actuality.subtitleEn = this.actualityInfo.overviewEn;
      this.actuality.description = this.actualityInfo.description;
      this.actuality.descriptionEn = this.actualityInfo.descriptionEn;
      this.actuality.isLocked = this.actualityInfo.isLocked;
      this.actuality.actualityRank = this.actualityInfo.actualityRank;
      this.actuality.highlight = this.actualityInfo.highlight;
      this.actuality.highlightEn = this.actualityInfo.highlightEn;
      this.actuality.reportBy = this.actualityInfo.reportBy;
      this.actuality.authorCertificateId = this.certified
        ? this.authorSelected
        : -1;
      //console.log(this.actuality);

      const response = await fetch(
        Constant.QORANI + "actuality/edit/" + this.actualityInfo.id,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(this.actuality),
        }
      );

      try {
        /*this.$router.push({
          name: "Actuality",
        });*/
        this.$router.go(-1);
      } catch (error) {
        alert(
          "Une erreur est survenue lors de l'ajout du actuality, veuillez réessayez plus tard, Merci."
        );
      }

    },
    async uploadImageSuccess(formData, index, fileList) {
      try {
        await store.dispatch("uploadImageSuccess", {
          formData,
          index,
          fileList,
        });
        const imageId = store.state.imageId;
        this.actuality.imgUrlDBId = imageId;
        this.actuality.imgBannerUrDBlId = imageId;

        console.log("Image id :", imageId);
      } catch (error) {
        console.error("Failed to upload image:", error);
      }
    },
    async uploadImageSuccessBanner(formData, index, fileList) {
      try {
        await store.dispatch("uploadImageSuccessBanner", {
          formData,
          index,
          fileList,
        });
        const imageIdBanner = store.state.imageIdBanner;
        this.actuality.imgBannerUrDBlId = imageIdBanner;

        console.log("Image idBanner :", imageIdBanner);
      } catch (error) {
        console.error("Failed to upload image:", error);
      }
    },
    beforeRemove(index, done, fileList) {
      this.showlowding = false;
      this.fakePercentage = 0;
      this.uploadPercentage = 0;
      const r = confirm("remove image");
      if (r === true) {
        const indexInArrayImages = this.images.indexOf(fileList[index].path);
        this.actualityInfo.imgUrl = "";
        this.actualityInfo.imgId = "";
        if (index > -1) {
          this.images.splice(indexInArrayImages, 1);
        }

        done();
      }
    },
    beforeRemoveBanner(index, done, fileList) {
      this.showlowdingBanner = false;
      this.fakePercentage = 0;
      this.uploadPercentageBanner = 0;
      const r = confirm("remove image");
      if (r === true) {
        const indexInArrayImages = this.imagesBanner.indexOf(
          fileList[index].path
        );
        this.actualityInfo.imgBannerUrlId = "";
        this.actualityInfo.imgBannerUrl = "";
        if (index > -1) {
          this.imagesBanner.splice(indexInArrayImages, 1);
        }

        done();
      }
    },
  },
  async created() {
    this.ActualityDescItemist = await getAllActualityDescItem(
      this.$route.params.id
    );
    this.ActualityCategoryList = await getAllActualityCategory();
    console.log(this.ActualityCategoryList);
    this.tagsArray = await FetchAllTags();
  },
};
</script>
<style lang="css">
.image-overlay {
  z-index: 1 !important;
}

.image-overlay-details {
  z-index: 2 !important;
}


@import "~vue2-editor/dist/vue2-editor.css";

/* Import the Quill styles you want */
@import "~quill/dist/quill.core.css";
@import "~quill/dist/quill.bubble.css";
@import "~quill/dist/quill.snow.css";
</style>
